import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
    return (
        <div
            className="min-h-screen flex items-center justify-center bg-cover bg-center"
            style={{
                backgroundImage: "url('/images/yacht-bg.jpg')",
            }}
        >
            <div className="text-center p-8 bg-white bg-opacity-10 backdrop-blur-md rounded-xl shadow-2xl max-w-2xl mx-4">
                <h1 className="text-6xl font-bold text-white mb-4">404</h1>
                <h2 className="text-2xl font-semibold text-white mb-4">
                    Oops! Yanlış Rotadasınız
                </h2>
                <p className="text-gray-200 mb-8">
                    Aradığınız sayfa denizlerin derinliklerinde kaybolmuş gibi
                    görünüyor. Ana limana dönmek için aşağıdaki butonu
                    kullanabilirsiniz.
                </p>
                <Link
                    to="/"
                    className="inline-block px-6 py-3 bg-white text-blue-900 font-semibold rounded-lg hover:bg-blue-100 transition-colors duration-300"
                >
                    Ana Sayfaya Dön
                </Link>
            </div>
        </div>
    );
};

export default NotFoundPage;
